module.exports = __webpack_public_path__ + "static/media/minus.6e49897f.svg";